import Dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
Dayjs.extend(duration)

for (const k of Object.keys(Dayjs)) {
  newDayjs[k] = Dayjs[k]
}

function newDayjs (...age) {
  const value = Dayjs(...age)
  const t = age[0]
  if (t === null || t == 0) {
    value.format = (...formatAge) => '-'
  }
  return value
}

export default newDayjs
